import { render, staticRenderFns } from "./CreateElement.vue?vue&type=template&id=ed5a4206"
import script from "./CreateElement.vue?vue&type=script&lang=js"
export * from "./CreateElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports